import * as TinyMce from '@tinymce/tinymce-react';
import * as React from 'react';
import { WelcomeChannelStyles } from '../../../../home/styles/WelcomeChannelStyles';

// Manually import tinyMCE and the themes because the tinymce-react fetches them from tinymce's CDN by default.
import 'tinymce/tinymce.min.js';

import 'tinymce/plugins/autolink/plugin.js';
import 'tinymce/plugins/link/plugin.js';
import 'tinymce/plugins/paste/plugin.js';
import 'tinymce/plugins/quickbars/plugin.js';

import 'tinymce/skins/ui/oxide/content.inline.min.css';
import 'tinymce/skins/ui/oxide/skin.min.css';
import 'tinymce/themes/silver/theme.min.js';
import './TinyEditorStyles.ts';

export type TinyEditorChangeHandler = (value: string) => void;
type TinyEditor = React.FunctionComponent<TinyEditorProps>;

export interface TinyEditorProps {
  readonly id: string;
  readonly editorConfig: Record<string, any>;
  readonly formName: string;
  readonly value: string;
  readonly changeHandler: TinyEditorChangeHandler;
}

/**
 * Use LazyTinyEditor instead of this component
 */
export const TinyEditorComponent: TinyEditor = React.memo((props: TinyEditorProps) =>
  <footer className={WelcomeChannelStyles.footer}>
    <div id={props.id} className={WelcomeChannelStyles.editModeOutline} data-tb-test-id={'server-footer-input'} /> {/* Editor Container */}
    <TinyMce.Editor
      value={props.value}
      onEditorChange={(value: string) => props.changeHandler(value)}
      init={props.editorConfig}
    />
  </footer>);

export default TinyEditorComponent;
